module.exports = __webpack_public_path__ + "img/columns.636f1b5b.svg";